export default __webpack_public_path__ + "static/media/plus.1cd40159.svg";